import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'
import {getMsgList, getMsgType} from '@/api/server/message'

import Banner from '@/components/Banner'
import Contact from '@/components/Contact'

export default {
  name: 'NoticePage',
  mixins: [commonMixin],
  data () {
    return {
      pagesize: 10,
      page: 1,
      total: 0,
      typeList: [],
      selectType: 0, //选中类别
      list: []
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    Banner,
    Contact
  },
  computed: {
  },
  methods: {
    currentPageChange (currentPage) {
      this.page = currentPage
      this._getList()
    },
    onChangeType (typeItem) {
      if (typeItem && typeItem.id) {
        this.selectType = typeItem.id
      } else {
        this.selectType = 0
      }
      this.page = 1
      this._getList()
      console.log('selectType', this.selectType)
    },
    onDetail (item) {
      this.$router.push({name: 'notice-detail', query: {id: item.id}})
    },
    _getList () {
      let query = {
          page: this.page,
          pagesize: this.pagesize,
          type: this.selectType
      }
      getMsgList(query).then((data) => {
        if (data.code === 200 && data.data && data.data.data) {
            let rdata = data.data
            this.list = rdata.data
            this.total = rdata.total
        } else {
            this.warning(data.message)
        }
      }).catch((e) => {
        console.log('err', e)
      })
    },
    _getType () {
      getMsgType().then((res) => {
        if (res.code === 200) {
          this.typeList =res.data
        }
      })
    },
    reset () {
      this.page = 1
      this.selectType = 0
      this._getType()
      this._getList()
      
    },
    handleRoute (route) {
      if (route.name === 'notice') {
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}
